export const types = [
    { text: 'Blog', value: 'BLOG', icon: 'mdi-newspaper-variant-outline' },
    { text: 'Video', value: 'VIDEO', icon: 'mdi-play-circle'},
    { text: 'Liga Adjunta', value: 'LINK', icon: 'mdi-link-variant' },
    { text: 'Archivo Adjunto', value: 'DOC', icon: 'mdi-file-document-multiple' },
    // { text: 'Encuesta', value: 'POLL', icon: 'mdi-help-box-multiple', disabled: true  },
  ]
